import { render, staticRenderFns } from "./CoreDialog.vue?vue&type=template&id=73c74afe&scoped=true&"
import script from "./CoreDialog.vue?vue&type=script&lang=js&"
export * from "./CoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoreDialog.vue?vue&type=style&index=0&id=73c74afe&prod&lang=css&"
import style1 from "./CoreDialog.vue?vue&type=style&index=1&id=73c74afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c74afe",
  null
  
)

export default component.exports